<template lang="pug">
div(class="banner-carousel mx-auto w-full")
    Banner(v-if="banners[$device.key].length == 1" :banner="banners[$device.key][0]" :size="size")
    div(v-else)
        Carousel(arrowMode="ALWAYS" arrowStyle="THIN" isLooped)
            div(v-for="(banner, index) in banners[$device.key]" :key="banner.image.filename" class="min-w-full")
                Banner(:banner="banner" :size="size" :isLazy="index > 0")
</template>
<script>
import Carousel from '@/components/carousel'
import Banner from './_components/banner'

export default {
    components: {
        Banner,
        Carousel,
    },
    props: {
        // assumes the obj has .desktop[] and .mobile[]
        banners: {
            type: Object,
            required: true,
        },
        size: {
            type: String,
            default: 'CATALOG',
            validator: (value) => {
                return value === 'CATALOG' || value === 'HOME' || value === 'BLOG'
            },
        },
    },
}
</script>

<style lang="stylus" scoped>
.banner-carousel
    max-width 1920px
</style>
